<template>
  <div id="app" class="tech-blue-theme">
    <!-- 导航栏 -->
    <nav class="navbar" :class="{ scrolled: scrolled }">
      <div class="nav-container">
        <div class="logo">
          <!-- 去掉文字 Y，用 CSS 背景图 -->
          <div class="logo-icon logo-bg"></div>
          <div class="logo-text">
            <h1>亿丰行集团</h1>
            <span>YiFengHang Group</span>
          </div>
        </div>
        <ul class="nav-links" :class="{ active: mobileMenuOpen }">
          <li v-for="item in navItems" :key="item.id">
            <a @click="scrollToSection(item.id)" :class="{ active: currentSection === item.id }">
              {{ item.name }}
            </a>
          </li>
        </ul>
        <div class="mobile-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
          <span></span><span></span><span></span>
        </div>
      </div>
    </nav>

    <!-- 首页 Hero -->
    <section id="home" class="hero">
      <div class="hero-bg">
        <div class="particles">
          <div v-for="n in 20" :key="n" class="particle" :style="particleStyle(n)"></div>
        </div>
      </div>
      <div class="hero-content">
        <div class="hero-badge">始于1996 · 三十年行业沉淀</div>
        <h1 class="hero-title">一站式化工贸易服务商</h1>
        <p class="hero-subtitle">
          深耕氯化溶液及油脂化工领域，架起连接全球化工资源的桥梁<br />
          以品质为先、服务为本对话世界
        </p>
        <div class="hero-stats">
          <div class="stat-item" v-for="stat in heroStats" :key="stat.label">
            <div class="stat-number">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
        <div class="hero-cta">
          <button class="btn-primary" @click="scrollToSection('products')">
            浏览产品
          </button>
          <button class="btn-outline" @click="scrollToSection('contact')">
            联系我们
          </button>
        </div>
        <!-- 公司大楼航拍位置 -->
      <div class="hero-image">
        <div class="image-placeholder building-aerial" style="margin-left: 30px;">
          <!-- <div class="placeholder-icon">🏢</div> -->
          <!-- <span>公司大楼航拍图</span> -->
          <img src="./assets/images/公司总部航拍图.jpg" style="width: 100%;height:100%;" />
          <!-- <small>建议尺寸：1920x1080</small> -->
        </div>
      </div>
      </div>
      
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">ABOUT US</span>
          <h2>关于亿丰行</h2>
          <p>三十年砥砺奋进，跨越山与海的疆界</p>
        </div>

        <div class="about-grid">
          <div class="about-card main-card">
            <div class="card-icon">🎯</div>
            <h3>集团简介</h3>
            <p>
              公司成立于1996年，总部坐落于大湾区交通枢纽东莞茶山镇，周边立体交通网络完善。企业配套超3000平方米现代化办公区域与超5000平方米物流仓储空间，旗下设有东莞市亿丰行洗涤产品有限公司、广州市亿丰行化工有限公司、广州亿丰行进出口有限公司、广州散化化工有限公司和深圳市丰宇化工科技有限公司多家分公司，是集全球知名化工品牌代理、仓储物流及跨境贸易于一体的大型综合性企业。
            </p>
          </div>

          <div class="about-card">
            <div class="card-icon">🏆</div>
            <h3>行业领军</h3>
            <p>
              三十年行业经验沉淀，铸就化工贸易领域的领军企业，携手分公司构成综合贸易服务矩阵。
            </p>
          </div>

          <div class="about-card">
            <div class="card-icon">🌐</div>
            <h3>全球布局</h3>
            <p>
              紧跟"一带一路"建设，产品远销东南亚、中东等地，构建全球化物流服务网络。
            </p>
          </div>

          <div class="about-card">
            <div class="card-icon">⚡</div>
            <h3>智能高效</h3>
            <p>
              运用供应链管理系统和智能数据分析优化采购策略，实现24小时快速响应机制。
            </p>
          </div>
        </div>

        <!-- 公司门口厂牌位置 -->
        <div class="showcase-row">
          <div class="showcase-item">
            <div class="image-placeholder company-gate">
              <img src="./assets/images/公司外部厂名.jpg" style="width: 100%;height:100%;" />
              <!-- <div class="placeholder-icon">🚪</div>
              <span>公司门口厂牌</span>
              <small>建议尺寸：800x600</small> -->
            </div>
          </div>
          <div class="showcase-item text-content">
            <h3>总部基地</h3>
            <p>
              位于东莞茶山镇，覆盖立体交通网络，坐拥大湾区核心区位优势，辐射华南、华东、华北、西南四大区域。
            </p>
            <ul class="feature-list">
              <li><span class="check">✓</span> 3000㎡+ 现代化办公空间</li>
              <li><span class="check">✓</span> 5000㎡+ 智能物流仓储</li>
              <li><span class="check">✓</span> 四大区域仓储中心覆盖</li>
            </ul>
          </div>
        </div>

        <!-- 前台接待区位置 -->
        <div class="showcase-row reverse">
          <div class="showcase-item text-content">
            <h3>专业服务</h3>
            <p>
              以专业与高效赢得客户信赖，建立全流程质量追溯体系，为每一笔交易筑起坚实的品质防线。
            </p>
            <div class="service-tags">
              <span class="tag">品质为先</span>
              <span class="tag">服务为本</span>
              <span class="tag">精准对接</span>
              <span class="tag">降本增效</span>
            </div>
          </div>
          <div class="showcase-item">
            <div class="image-placeholder reception">
              <img src="./assets/images/公司内部前台照片.jpg" style="width: 100%;height:100%;" />
              <!-- <div class="placeholder-icon">🛋️</div>
              <span>前台接待区</span>
              <small>建议尺寸：800x600</small> -->
            </div>
          </div>
        </div>
      </div>
    </section>

   <!-- 合作伙伴 -->
   <section id="logistics" class="logistics">
      <div class="container">
        <div class="section-header" style="margin-bottom: 2rem;">
          <span class="section-tag">PARTNER</span>
          <h2>合作伙伴</h2>
          <p>联袂国内外顶尖化工品牌，构建多元化产品结构</p>
        </div>

        <div class="network-section" style=" display: flex;justify-content: center;align-items: center;">
          <div class="image-placeholder network-map-1" style="height: 300px;width: 600px;">
            <img src="./assets/images/国内外合作厂商LOGO.png" style="width: 100%;height:100%;" />
          </div>
        </div>

      </div>
    </section>

    <!-- 企业宣传片 -->
    <section id="video" class="video-section">
      <div class="container">
        <div class="section-header light">
          <span class="section-tag">CORPORATE VIDEO</span>
          <h2>企业宣传片</h2>
          <p>见证亿丰行三十年发展历程与全球化布局</p>
        </div>
        <div class="video-container">
          <div class="video-placeholder" @click="playVideo">
            <!-- <div class="play-button">
              <div class="play-icon">▶</div>
            </div> -->
            <!-- <p class="video-hint">点击播放企业宣传片</p> -->
            <video style="width: 100%;height: 100%;" controls>
              <!-- <source src="https://nie.v.netease.com/r/video/20210203/ee945fd5-3d24-415d-a5c4-da02ec7895f9.mp4" type="video/mp4" />  -->
              <source src="./assets/images/11月17日.mp4" type="video/mp4" />
              您的浏览器不支持 HTML5 视频。
            </video>
            <!-- <p class="video-subhint">请替换为实际视频文件或嵌入视频链接</p> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 产品中心 -->
    <section id="products" class="products">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">PRODUCTS</span>
          <h2>产品中心</h2>
          <p>联袂国内外顶尖化工品牌，满足客户多样化需求</p>
        </div>

        <div class="products-grid">
          <div class="product-card" v-for="(product, index) in products" :key="index" :class="{ featured: index < 4 }">
            <div class="product-header">
              <div class="product-icon">{{ product.icon }}</div>
              <h4>{{ product.name }}</h4>
            </div>
            <div class="product-body">
              <p>{{ product.desc }}</p>
              <span class="product-tag">{{ product.category }}</span>
            </div>
            <div class="product-footer">
              <button class="btn-small">了解详情</button>
            </div>
          </div>
        </div>

        <div class="products-summary">
          <div class="summary-item">
            <div class="summary-icon">🧪</div>
            <div class="summary-info">
              <h4>氯化溶液系列</h4>
              <p>二氯甲烷、四氯乙烯、三氯乙烯、二氯一氟乙烷等</p>
            </div>
          </div>
          <div class="summary-item">
            <div class="summary-icon">🛢️</div>
            <div class="summary-info">
              <h4>油脂化工系列</h4>
              <p>甘油、硬脂酸、油酸、棕榈酸、肉豆蔻酸等</p>
            </div>
          </div>
          <div class="summary-item">
            <div class="summary-icon">⚗️</div>
            <div class="summary-info">
              <h4>特种溶剂系列</h4>
              <p>四氢呋喃、甲基异丁基酮、正丙醇、氢氟醚、乙二醇丁醚（BCS）、二乙二醇丁醚（DB）、二异丁基酮（DIBK）等</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 物流网络 -->
    <section id="logistics" class="logistics">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">LOGISTICS</span>
          <h2>物流网络</h2>
          <p>物流为基连接全球，以质致远共筑未来</p>
        </div>

        <div class="logistics-showcase">
          <!-- 物流园航拍图位置 -->
          <div class="logistics-image main">
            <div class="image-placeholder logistics-aerial" style="background-image: url('./assets/images/公司总部航拍图.jpg');">
              <img src="./assets/images/公司物流园航拍图.jpg" style="width: 100%;height:100%;" />
              <!-- <div class="placeholder-icon">📦</div>
              <span>公司物流园航拍图</span>
              <small>建议尺寸：1200x800</small> -->
            </div>
          </div>

          <div class="logistics-features">
            <div class="feature-card" v-for="feature in logisticsFeatures" :key="feature.title">
              <div class="feature-num">{{ feature.num }}</div>
              <h4>{{ feature.title }}</h4>
              <p>{{ feature.desc }}</p>
            </div>
          </div>
        </div>

        <!-- 物流配送网络图1 -->
        <div class="network-section">
          <h3 class="network-title">全国仓储配送网络</h3>
          <div class="image-placeholder network-map-1">
            <img src="./assets/images/物流配送网络图2.png" style="width: 100%;height:100%;" />
            <!-- <div class="placeholder-icon">🗺️</div>
            <span>全国物流配送网络图（华南/华东/华北/西南四大仓储中心）</span>
            <small>建议尺寸：1200x600</small> -->
          </div>
        </div>

        <!-- 物流配送网络图2 -->
        <div class="network-section">
          <h3 class="network-title">全球贸易网络</h3>
          <div class="image-placeholder network-map-2">
            <img src="./assets/images/物流配送网络图1.png" style="width: 100%;height:100%;" />
            <!-- <div class="placeholder-icon">🌍</div>
            <span>全球跨境物流配送网络图（东南亚/中东/一带一路沿线）</span>
            <small>建议尺寸：1200x600</small> -->
          </div>
        </div>

        <div class="logistics-stats">
          <div class="l-stat" v-for="stat in logisticsStats" :key="stat.label">
            <div class="l-stat-icon">{{ stat.icon }}</div>
            <div class="l-stat-value">{{ stat.value }}</div>
            <div class="l-stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻动态 -->
    <section id="news" class="news">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">NEWS</span>
          <h2>新闻动态</h2>
          <p>关注亿丰行最新发展与行业资讯</p>
        </div>

        <div class="news-grid">
          <div class="news-card featured">
            <div class="news-date">
              <span class="day">15</span>
              <span class="month">2026.07</span>
            </div>
            <div class="news-content">
              <span class="news-tag">企业动态</span>
              <h4>亿丰行深化全球资源布局，拓展东南亚市场新通道</h4>
              <p>
                公司积极响应"一带一路"倡议，与东南亚多家化工企业建立战略合作关系，进一步完善全球化供应链体系...
              </p>
              <a class="read-more">阅读更多 →</a>
            </div>
          </div>

          <div class="news-card">
            <div class="news-date">
              <span class="day">22</span>
              <span class="month">2026.06</span>
            </div>
            <div class="news-content">
              <span class="news-tag">行业资讯</span>
              <h4>智能仓储管理系统全面升级，实现24小时快速响应</h4>
              <p>通过引入先进的WMS仓储管理系统与动态调度技术...</p>
              <a class="read-more">阅读更多 →</a>
            </div>
          </div>

          <div class="news-card">
            <div class="news-date">
              <span class="day">10</span>
              <span class="month">2026.05</span>
            </div>
            <div class="news-content">
              <span class="news-tag">产品发布</span>
              <h4>新型环保氟化液产品正式上线，助力绿色化工发展</h4>
              <p>公司携手国际顶尖品牌推出新一代环保型氟化液产品...</p>
              <a class="read-more">阅读更多 →</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact">
      <div class="container">
        <div class="section-header light">
          <span class="section-tag">CONTACT</span>
          <h2>联系我们</h2>
          <p>期待与全球伙伴携手，共筑化工行业未来新篇章</p>
        </div>

        <div class="contact-grid">
          <div class="contact-info">
            <div class="info-card">
              <div class="info-icon">📍</div>
              <h4>总部地址</h4>
              <p>广东省东莞市茶山镇<br />北路2号</p>
            </div>
            <div class="info-card">
              <div class="info-icon">📞</div>
              <h4>联系电话</h4>
              <p>手机：13826963966</p>
              <p>固话：0769-86311487</p>
              
            </div>
            <div class="info-card">
              <div class="info-icon">✉️</div>
              <h4>电子邮箱</h4>
              <p>Yang.yuan@dgyfh.com</p>
            </div>
            <div class="info-card">
              <div class="info-icon">🕐</div>
              <h4>工作时间</h4>
              <p>周一至周六 8:30-18:00</p>
            </div>
          </div>

          <div class="contact-form-wrapper">
            <form class="contact-form" @submit.prevent="submitForm">
              <h3>在线咨询</h3>
              <div class="form-row">
                <div class="form-group">
                  <input type="text" v-model="form.name" placeholder="您的姓名" required />
                </div>
                <div class="form-group">
                  <input type="tel" v-model="form.phone" placeholder="联系电话" required />
                </div>
              </div>
              <div class="form-group">
                <input type="email" v-model="form.email" placeholder="电子邮箱" />
              </div>
              <div class="form-group">
                <select v-model="form.interest">
                  <option value="">咨询类型</option>
                  <option value="product">产品咨询</option>
                  <option value="cooperation">商务合作</option>
                  <option value="logistics">物流配送</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div class="form-group">
                <textarea v-model="form.message" placeholder="请输入您的留言内容..." rows="4"></textarea>
              </div>
              <button type="submit" class="btn-submit">提交咨询</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="logo">
              <div class="logo-icon logo-bg"></div>
              <div class="logo-text">
                <h3>亿丰行集团</h3>
                <span>YiFengHang Group</span>
              </div>
            </div>
            <p>一站式化工贸易服务商<br />以品质铸就信任，以服务链接世界</p>
          </div>

          <div class="footer-links">
            <h4>快速导航</h4>
            <ul>
              <li><a @click="scrollToSection('home')">首页</a></li>
              <li><a @click="scrollToSection('about')">关于我们</a></li>
              <li><a @click="scrollToSection('products')">产品中心</a></li>
              <li><a @click="scrollToSection('logistics')">物流网络</a></li>
            </ul>
          </div>

          <div class="footer-links">
            <h4>产品系列</h4>
            <ul>
              <li><a>氯化溶液</a></li>
              <li><a>油脂化工</a></li>
              <li><a>工业清洗</a></li>
              <li><a>特种溶剂</a></li>
            </ul>
          </div>

          <div class="footer-links">
            <h4>联系方式</h4>
            <ul>
              <li>广东省东莞市茶山镇茶山北路2号</li>
              <li>固话：0769-86311487</li>
              <li>手机：13826963966</li>
              <li>电子邮箱：Yang.yuan@dgyfh.com</li>
            </ul>
          </div>
        </div>

        <div class="footer-bottom">
          <p>
            © 2026 东莞市亿丰行洗涤产品有限公司 版权所有 | 粤ICP备17040447号-1
          </p>
        </div>
      </div>
    </footer>

    <!-- 回到顶部 -->
    <div class="back-to-top" v-show="scrolled" @click="scrollToTop">↑</div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

// 导航数据
const navItems = [
  { id: "home", name: "首页" },
  { id: "about", name: "关于我们" },
  { id: "products", name: "产品中心" },
  { id: "logistics", name: "物流网络" },
  { id: "news", name: "新闻动态" },
  { id: "contact", name: "联系我们" },
];

// 首页统计数据
const heroStats = [
  { value: "30+", label: "年行业经验" },
  { value: "5000㎡", label: "物流仓储" },
  { value: "4", label: "大区域覆盖" },
  { value: "20+", label: "核心产品系列" },
];

// 产品数据
const products = [
  {
    name: "二氯甲烷",
    desc: "高纯度氯化溶剂，广泛应用于医药、涂料、清洗剂等领域",
    category: "氯化溶液",
    icon: "💧",
  },
  {
    name: "四氯乙烯",
    desc: "优质干洗溶剂及金属清洗剂原料，脱脂能力强",
    category: "氯化溶液",
    icon: "⚗️",
  },
  {
    name: "三氯乙烯",
    desc: "工业级精密清洗剂，电子元件清洗及金属脱脂首选",
    category: "氯化溶液",
    icon: "🔬",
  },
  {
    name: "工业清洗剂",
    desc: "专业配方清洗剂，满足各类工业清洗场景需求",
    category: "清洗产品",
    icon: "🧼",
  },
  {
    name: "四氢呋喃",
    desc: "通用型有机溶剂，优良的溶解性能，化工合成重要原料",
    category: "特种溶剂",
    icon: "⚡",
  },
  {
    name: "甘油",
    desc: "高纯度丙三醇，广泛应用于食品、医药、化妆品工业",
    category: "油脂化工",
    icon: "💎",
  },
  {
    name: "甲基异丁基酮",
    desc: "MIBK溶剂，优良的中沸点溶剂，涂料及树脂行业常用",
    category: "特种溶剂",
    icon: "🔥",
  },
  {
    name: "硬脂酸",
    desc: "天然脂肪酸，塑料加工、橡胶工业、化妆品基础原料",
    category: "油脂化工",
    icon: "🧪",
  },
  {
    name: "油酸",
    desc: "不饱和脂肪酸，表面活性剂、润滑剂、纺织助剂原料",
    category: "油脂化工",
    icon: "💧",
  },
  {
    name: "正丙醇",
    desc: "正丙醇溶剂，涂料、油墨、清洁剂配方常用组分",
    category: "特种溶剂",
    icon: "📐",
  },
  {
    name: "碳氢清洗剂",
    desc: "环保型碳氢清洗溶剂，替代传统氯化溶剂，绿色高效",
    category: "清洗产品",
    icon: "🌿",
  },
  {
    name: "乳化剂",
    desc: "专业乳化配方产品，稳定乳状液体系，工业应用广泛",
    category: "助剂",
    icon: "🔵",
  },
  {
    name: "棕榈酸",
    desc: "十六烷酸，香皂、蜡烛、化妆品重要原料",
    category: "油脂化工",
    icon: "🌴",
  },
  // { name: '二氯一氟乙烷', desc: 'HCFC类清洗剂，精密电子清洗及制冷剂应用', category: '氯化溶液', icon: '❄️' },
  {
    name: "氢氟醚",
    desc: "HFE环保溶剂，电子清洗、精密仪器清洗专用",
    category: "特种溶剂",
    icon: "💨",
  },
  {
    name: "氟化液",
    desc: "电子氟化液，数据中心浸没式冷却、电子清洗专用",
    category: "特种溶剂",
    icon: "🧊",
  },
  {
    name: "乙二醇丁醚（BCS）",
    desc: "一元醇醚类，小防白水，涂料油墨、工业清洗、配套化工原料",
    category: "特种溶剂",
    icon: "💨",
  },
  {
    name: "二乙二醇丁醚（DB）",
    desc: "二元醇醚类，大防白水，涂料油墨、精密清洗、配套化工原料",
    category: "特种溶剂",
    icon: "💨",
  },
  {
    name: "二异丁基酮（DIBK）",
    desc: "脂肪族酮类，高端涂料、精密清洗、特种工业配套化工原料",
    category: "特种溶剂",
    icon: "💨",
  },
  {
    name: "聚对苯二甲酸丙二醇酯",
    desc: "PTT高分子材料，纤维、薄膜、工程塑料应用",
    category: "高分子",
    icon: "🔗",
  },

  {
    name: "除蜡水",
    desc: "专业除蜡配方，金属表面处理、珠宝清洗高效去蜡",
    category: "清洗产品",
    icon: "✨",
  },
  {
    name: "肉豆蔻酸",
    desc: "十四烷酸，化妆品、香料、表面活性剂基础原料",
    category: "油脂化工",
    icon: "🌸",
  },
];

// 物流特色
const logisticsFeatures = [
  {
    num: "01",
    title: "四大区域仓储",
    desc: "华南、华东、华北、西南四大区域设立仓储中心，构建覆盖全国的物流网络",
  },
  {
    num: "02",
    title: "智能仓储管理",
    desc: "通过智能仓储管理系统与动态调度技术，实现库存精准管理与高效调配",
  },
  {
    num: "03",
    title: "24小时响应",
    desc: "快速响应机制与高效配送服务，大幅降低客户运输成本，提高交付效率",
  },
  {
    num: "04",
    title: "跨境贸易网络",
    desc: '紧跟"一带一路"建设，产品远销东南亚、中东等地，提供定制化物流解决方案',
  },
];

// 物流统计
const logisticsStats = [
  { icon: "📦", value: "5000㎡+", label: "仓储面积" },
  { icon: "🚚", value: "24h", label: "快速响应" },
  { icon: "🌏", value: "10+", label: "覆盖国家" },
  { icon: "🏭", value: "4", label: "区域中心" },
];

// 响应式状态
const scrolled = ref(false);
const mobileMenuOpen = ref(false);
const currentSection = ref("home");

// 表单数据
const form = ref({
  name: "",
  phone: "",
  email: "",
  interest: "",
  message: "",
});

// 粒子动画样式
const particleStyle = () => {
  return {
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 5}s`,
    animationDuration: `${5 + Math.random() * 10}s`,
    opacity: 0.1 + Math.random() * 0.3,
  };
};

// 滚动处理
const handleScroll = () => {
  scrolled.value = window.scrollY > 50;

  // 检测当前区域
  const sections = navItems.map((item) => item.id);
  for (const id of sections.reverse()) {
    const element = document.getElementById(id);
    if (element) {
      const rect = element.getBoundingClientRect();
      if (rect.top <= 100) {
        currentSection.value = id;
        break;
      }
    }
  }
};

// 滚动到指定区域
const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
    mobileMenuOpen.value = false;
  }
};

// 回到顶部
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

// 播放视频
const playVideo = () => {
  alert("请在此处嵌入企业宣传片视频文件或视频链接");
};

// 提交表单
const submitForm = () => {
  alert("感谢您的咨询！我们会尽快与您联系。");
  form.value = { name: "", phone: "", email: "", interest: "", message: "" };
};

// 生命周期
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style>
/* ==================== 全局变量与主题 ==================== */
:root {
  --primary: #0a2540;
  --primary-light: #1a3a5c;
  --primary-dark: #061827;
  --accent: #00d4ff;
  --accent-dark: #00a8cc;
  --accent-glow: rgba(0, 212, 255, 0.3);
  --text-primary: #e6f1ff;
  --text-secondary: #8892b0;
  --text-muted: #546a8a;
  --bg-primary: #0a192f;
  --bg-secondary: #112240;
  --bg-card: #162a4a;
  --bg-card-hover: #1d3a63;
  --border: #1d4e7a;
  --border-light: #2a6fa8;
  --gradient-1: #0a2540;
  --gradient-2: #112240;
  --shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5);
  --shadow-glow: 0 0 20px rgba(0, 212, 255, 0.15);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.tech-blue-theme {
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  background: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  overflow-x: hidden;
}

/* ==================== 导航栏 ==================== */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  padding: 1rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.navbar.scrolled {
  background: rgba(10, 25, 47, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 0.5rem 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  width: 40px;
  height: 40px;
  color: var(--primary-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 8px;
}

.logo-text h1 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 3px;
}

.logo-text span {
  font-size: 0.65rem;
  color: var(--accent);
  letter-spacing: 3px;
  font-weight: 500;
}

.nav-links {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.nav-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.nav-links a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--accent);
  transition: width 0.3s ease;
}

.nav-links a:hover,
.nav-links a.active {
  color: var(--accent);
}

.nav-links a:hover::after,
.nav-links a.active::after {
  width: 100%;
}

.mobile-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
}

.mobile-toggle span {
  width: 25px;
  height: 2px;
  background: var(--accent);
  transition: all 0.3s ease;
}

/* ==================== 通用容器 ==================== */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-header.light {
  color: var(--text-primary);
}

.section-tag {
  display: inline-block;
  color: var(--accent);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 3px;
  margin-bottom: 1rem;
  position: relative;
}

.section-tag::before,
.section-tag::after {
  content: "—";
  margin: 0 1rem;
  color: var(--border);
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--text-primary), var(--accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-header p {
  color: var(--text-secondary);
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
}

/* ==================== Hero 首页 ==================== */
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  padding: 8rem 2rem 4rem;
  background: linear-gradient(135deg,
      var(--gradient-1) 0%,
      var(--gradient-2) 100%);
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.particles {
  position: absolute;
  inset: 0;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--accent);
  border-radius: 50%;
  animation: float 10s infinite ease-in-out;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0) translateX(0);
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  50% {
    transform: translateY(-100px) translateX(50px);
  }
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-badge {
  display: inline-block;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--border);
  color: var(--accent);
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  letter-spacing: 2px;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #fff 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin-bottom: 3rem;
  line-height: 1.8;
}

.hero-stats {
  display: flex;
  gap: 3rem;
  margin-bottom: 3rem;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--accent);
  line-height: 1;
}

.stat-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
  letter-spacing: 1px;
}

.hero-cta {
  display: flex;
  gap: 1rem;
}

.btn-primary {
  background: var(--accent);
  color: var(--primary-dark);
  border: none;
  padding: 1rem 2.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.4);
}

.btn-outline {
  background: transparent;
  color: var(--accent);
  border: 2px solid var(--accent);
  padding: 1rem 2.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: rgba(0, 212, 255, 0.1);
  transform: translateY(-2px);
}

.hero-image {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  width: 40%;
  max-width: 500px;
}

/* ==================== 图片占位符样式 ==================== */
.image-placeholder {
  background: var(--bg-card);
  /* border: 2px dashed var(--border); */
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.image-placeholder:hover {
  border-color: var(--accent);
  box-shadow: var(--shadow-glow);
}

.placeholder-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.6;
}

.image-placeholder span {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.image-placeholder small {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.building-aerial {
  width: 100%;
  height: 400px;
  background: linear-gradient(135deg,
      var(--bg-card) 0%,
      var(--bg-secondary) 100%);
}

.company-gate,
.reception {
  width: 100%;
  height: 350px;
}

.logistics-aerial {
  width: 100%;
  height: 450px;
}

.network-map-1,
.network-map-2 {
  width: 100%;
  height: 400px;
  margin: 2rem 0;
}

/* ==================== 关于我们 ==================== */
.about {
  padding: 6rem 0;
  background: var(--bg-primary);
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 4rem;
}

.about-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 2.5rem;
  transition: all 0.3s ease;
}

.about-card:hover {
  transform: translateY(-5px);
  border-color: var(--accent);
  box-shadow: var(--shadow-glow);
}

.about-card.main-card {
  grid-column: 1 / -1;
  background: linear-gradient(135deg,
      var(--bg-card) 0%,
      var(--primary-light) 100%);
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
}

.about-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--accent);
}

.about-card p {
  color: var(--text-secondary);
  line-height: 1.8;
}

.showcase-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 4rem;
}

.showcase-row.reverse {
  direction: rtl;
}

.showcase-row.reverse>* {
  direction: ltr;
}

.showcase-item.text-content h3 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
}

.showcase-item.text-content p {
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 2rem;
}

.feature-list {
  list-style: none;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
}

.check {
  color: var(--accent);
  font-weight: bold;
}

.service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.tag {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--border);
  color: var(--accent);
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.tag:hover {
  background: rgba(0, 212, 255, 0.2);
  border-color: var(--accent);
}

/* ==================== 视频区域 ==================== */
.video-section {
  padding: 6rem 0;
  background: linear-gradient(135deg,
      var(--primary-dark) 0%,
      var(--primary) 100%);
  position: relative;
}

.video-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300d4ff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
}

.video-container {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.video-placeholder {
  aspect-ratio: 16/9;
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.video-placeholder:hover {
  border-color: var(--accent);
  box-shadow: 0 0 40px rgba(0, 212, 255, 0.2);
}

.video-placeholder:hover .play-button {
  transform: scale(1.1);
  background: var(--accent);
}

.play-button {
  width: 80px;
  height: 80px;
  background: rgba(0, 212, 255, 0.2);
  border: 3px solid var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  margin-bottom: 1.5rem;
}

.play-icon {
  color: var(--accent);
  font-size: 2rem;
  margin-left: 5px;
}

.video-hint {
  color: var(--text-primary);
  font-size: 1.2rem;
  font-weight: 600;
}

.video-subhint {
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

/* ==================== 产品中心 ==================== */
.products {
  padding: 6rem 0;
  background: var(--bg-secondary);
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 4rem;
}

.product-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.product-card:hover {
  transform: translateY(-5px);
  border-color: var(--accent);
  box-shadow: var(--shadow-glow);
}

.product-card.featured {
  border-color: var(--border-light);
  background: linear-gradient(135deg,
      var(--bg-card) 0%,
      rgba(0, 212, 255, 0.05) 100%);
}

.product-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.product-icon {
  font-size: 2rem;
}

.product-header h4 {
  font-size: 1.1rem;
  color: var(--text-primary);
}

.product-body {
  flex: 1;
}

.product-body p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.product-tag {
  display: inline-block;
  background: rgba(0, 212, 255, 0.1);
  color: var(--accent);
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
}

.product-footer {
  margin-top: 1rem;
}

.btn-small {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-secondary);
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
}

.btn-small:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.products-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 2rem;
}

.summary-item {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
}

.summary-icon {
  font-size: 2.5rem;
  flex-shrink: 0;
}

.summary-info h4 {
  color: var(--accent);
  margin-bottom: 0.5rem;
}

.summary-info p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

/* ==================== 物流网络 ==================== */
.logistics {
  padding: 6rem 0;
  background: var(--bg-primary);
}

.logistics-showcase {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 3rem;
  margin-bottom: 4rem;
  align-items: start;
}

.logistics-features {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.feature-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
}

.feature-card:hover {
  border-color: var(--accent);
  transform: translateX(5px);
}

.feature-num {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--accent);
  opacity: 0.5;
  line-height: 1;
}

.feature-card h4 {
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.feature-card p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
}

.network-section {
  margin-bottom: 3rem;
}

.network-title {
  font-size: 1.3rem;
  color: var(--accent);
  margin-bottom: 1.5rem;
  text-align: center;
}

.logistics-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-top: 4rem;
}

.l-stat {
  text-align: center;
  padding: 2rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.l-stat:hover {
  border-color: var(--accent);
  transform: translateY(-5px);
}

.l-stat-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.l-stat-value {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--accent);
  margin-bottom: 0.5rem;
}

.l-stat-label {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

/* ==================== 新闻动态 ==================== */
.news {
  padding: 6rem 0;
  background: var(--bg-secondary);
}

.news-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.news-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 2rem;
  display: flex;
  gap: 2rem;
  transition: all 0.3s ease;
}

.news-card:hover {
  border-color: var(--accent);
  transform: translateY(-3px);
  box-shadow: var(--shadow-glow);
}

.news-card.featured {
  grid-column: 1 / -1;
  background: linear-gradient(135deg,
      var(--bg-card) 0%,
      rgba(0, 212, 255, 0.05) 100%);
}

.news-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding-right: 2rem;
  border-right: 1px solid var(--border);
}

.news-date .day {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--accent);
  line-height: 1;
}

.news-date .month {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.news-content {
  flex: 1;
}

.news-tag {
  display: inline-block;
  background: rgba(0, 212, 255, 0.1);
  color: var(--accent);
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  margin-bottom: 1rem;
}

.news-content h4 {
  font-size: 1.2rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
  line-height: 1.4;
}

.news-content p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.read-more {
  color: var(--accent);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.read-more:hover {
  color: var(--text-primary);
}

/* ==================== 联系我们 ==================== */
.contact {
  padding: 6rem 0;
  background: linear-gradient(135deg,
      var(--primary) 0%,
      var(--primary-dark) 100%);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 4rem;
}

.contact-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
}

.info-card:hover {
  background: rgba(0, 212, 255, 0.05);
  border-color: var(--accent);
  transform: translateY(-5px);
}

.info-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.info-card h4 {
  color: var(--accent);
  margin-bottom: 0.5rem;
}

.info-card p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
}

.contact-form-wrapper {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 2.5rem;
}

.contact-form h3 {
  color: var(--text-primary);
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  background: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 1rem;
  color: var(--text-primary);
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: var(--text-muted);
}

.form-group select {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238892b0' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
}

.form-group select option {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.btn-submit {
  width: 100%;
  background: var(--accent);
  color: var(--primary-dark);
  border: none;
  padding: 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

/* ==================== 页脚 ==================== */
.footer {
  background: var(--primary-dark);
  padding: 4rem 0 2rem;
  border-top: 1px solid var(--border);
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 3rem;
}

.footer-brand .logo {
  margin-bottom: 1.5rem;
}

.footer-brand p {
  color: var(--text-secondary);
  line-height: 1.8;
}

.footer-links h4 {
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  font-size: 1rem;
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 0.75rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.footer-links a {
  color: var(--text-secondary);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: var(--accent);
}

.footer-bottom {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* ==================== 回到顶部 ==================== */
.back-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 50px;
  height: 50px;
  background: var(--accent);
  color: var(--primary-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 999;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.back-to-top:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.4);
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1024px) {
  .hero {
    flex-direction: column;
    text-align: center;
    padding-top: 6rem;
  }

  .hero-content {
    margin-bottom: 3rem;
  }

  .hero-stats {
    justify-content: center;
  }

  .hero-image {
    position: relative;
    right: auto;
    top: auto;
    transform: none;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }

  .about-grid {
    grid-template-columns: 1fr;
  }

  .about-card.main-card {
    grid-column: 1;
  }

  .showcase-row,
  .showcase-row.reverse {
    grid-template-columns: 1fr;
    direction: ltr;
  }

  .showcase-row.reverse>* {
    direction: ltr;
  }

  .logistics-showcase {
    grid-template-columns: 1fr;
  }

  .logistics-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-info {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .products-summary {
    grid-template-columns: 1fr;
  }

  .news-grid {
    grid-template-columns: 1fr;
  }

  .news-card.featured {
    grid-column: 1;
  }
}

@media (max-width: 768px) {
  .nav-links {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: rgba(10, 25, 47, 0.98);
    flex-direction: column;
    padding: 2rem;
    gap: 1.5rem;
    transform: translateY(-150%);
    transition: transform 0.3s ease;
    border-bottom: 1px solid var(--border);
  }

  .nav-links.active {
    transform: translateY(0);
  }

  .mobile-toggle {
    display: flex;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-stats {
    flex-wrap: wrap;
    gap: 1.5rem;
  }

  .stat-number {
    font-size: 2rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .contact-info {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-brand .logo {
    justify-content: center;
  }

  .logistics-stats {
    grid-template-columns: 1fr;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }
}

.logo-bg {
  background-image: url("/src/assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 50px;  
  height: 50px;
}
</style>
